
import MainLayout from "@/components/layout/MainLayout";
import SEOHead from "@/components/seo/SEOHead";
import StructuredData from "@/components/seo/StructuredData";

const Termos = () => {
  // Structured data for breadcrumbs
  const breadcrumbData = {
    itemListElement: [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://vivecalme.org"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Termos de Uso",
        "item": "https://vivecalme.org/termos"
      }
    ]
  };

  return (
    <MainLayout showSidebar={false}>
      <SEOHead
        title="Termos de Uso | Vive Calme"
        description="Leia os termos e condições de uso da plataforma Vive Calme, incluindo políticas e responsabilidades."
        canonicalUrl="https://vivecalme.org/termos"
      />
      <StructuredData type="BreadcrumbList" data={breadcrumbData} />
      
      <div className="container mx-auto py-12 px-4">
        <h1 className="text-3xl font-bold mb-8">Termos de Uso</h1>
        
        <div className="prose max-w-none">
          <p className="mb-4">Última atualização: 14 de Maio de 2025</p>
          
          <h2 className="text-xl font-semibold mt-6 mb-4">1. Aceitação dos Termos</h2>
          <p className="mb-4">
            Ao acessar e usar o Vive Calme, você concorda em cumprir e ficar vinculado aos seguintes 
            termos e condições. Se você não concordar com qualquer parte destes termos, não poderá 
            acessar ou usar nossos serviços.
          </p>
          
          <h2 className="text-xl font-semibold mt-6 mb-4">2. Uso do Serviço</h2>
          <p className="mb-4">
            O Vive Calme é uma ferramenta de bem-estar que utiliza inteligência artificial para conversas 
            e reflexões. Não é um substituto para aconselhamento médico, terapia profissional ou tratamento 
            de saúde mental. Em caso de emergência ou crise, procure ajuda profissional imediatamente.
          </p>
          
          <h2 className="text-xl font-semibold mt-6 mb-4">3. Contas de Usuário</h2>
          <p className="mb-4">
            Para utilizar certos recursos do serviço, você precisará criar uma conta. Você é responsável 
            por manter a confidencialidade de suas credenciais e por todas as atividades que ocorrem sob 
            sua conta.
          </p>
          
          <h2 className="text-xl font-semibold mt-6 mb-4">4. Planos e Pagamentos</h2>
          <p className="mb-4">
            Oferecemos planos gratuitos e pagos. Ao assinar um plano pago, você concorda com os termos 
            de pagamento especificados durante o processo de compra. Os pagamentos são processados via 
            Stripe e estão sujeitos aos termos adicionais deste serviço.
          </p>
          
          <h2 className="text-xl font-semibold mt-6 mb-4">5. Privacidade</h2>
          <p className="mb-4">
            Sua privacidade é importante para nós. Por favor, consulte nossa Política de Privacidade 
            para entender como coletamos, usamos e protegemos seus dados.
          </p>
          
          <h2 className="text-xl font-semibold mt-6 mb-4">6. Limitações do Serviço de IA</h2>
          <p className="mb-4">
            O Vive Calme utiliza inteligência artificial e, como tal, está sujeito às limitações inerentes 
            a esta tecnologia. Não podemos garantir que o serviço seja livre de erros, imprecisões ou 
            conteúdo inadequado.
          </p>
          
          <h2 className="text-xl font-semibold mt-6 mb-4">7. Modificações dos Termos</h2>
          <p className="mb-4">
            Reservamo-nos o direito de modificar estes termos a qualquer momento. As alterações entrarão 
            em vigor após a publicação dos termos atualizados.
          </p>
          
          <h2 className="text-xl font-semibold mt-6 mb-4">8. Contato</h2>
          <p className="mb-4">
            Para questões relacionadas a estes termos, entre em contato conosco através do email: 
            contato@vivecalme.com
          </p>
        </div>
      </div>
    </MainLayout>
  );
};

export default Termos;
